module.exports = __webpack_public_path__ + "img/35-l.4b9a5e36.png";